module.exports = __webpack_public_path__ + "static/media/lira-sign.751fb851.svg";